/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: Paytable.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */ 
///<reference path="../constants/GameConstants.ts"/>

namespace Paytable {
    import PaytableData = DTO.Paytable;
    import AdpPhaserGame = Game.AdpPhaserGame;
    /**
     * Paytable class for the standard Paytable
     * In this case its used for both the Mobile and Desktop Client
     * If there are huge differences between the Views its better to create a Paytable class for mobile and one for desktop
     */
    export class GamePaytable extends PaytableView {
        public layoutConstants: typeof BS.HRGameLayoutConstants | typeof BS.SDGameLayoutConstants;

        constructor(game: AdpPhaserGame, bgImage: Phaser.Image, paytableData?: PaytableData, paytableStyle?: any) {
            super(game, bgImage, paytableData, paytableStyle);
        }

        /**
         * Used to create the Paygroups and Payitems from the paytabledata
         */
        protected createFromData() {
            let payItemTextFormat = this.style.payItemTextformat;
            let payGroups = [];
            for (let i = 0; i <= 6; i++) {
                if (i === 0) {
                    payGroups.push({style: this.style.payGroups[i], dto: this.paytableData.groups[0]});
                } else if (i === 1 || i === 2 || i === 3) {
                    payGroups.push({style: this.style.payGroups[i], dto: this.paytableData.groups[1]});
                } else if (i === 6) {
                    payGroups.push({style: this.style.payGroups[i], dto: this.paytableData.groups[3]});
                } else {
                    payGroups.push({style: this.style.payGroups[i], dto: this.paytableData.groups[2]});
                }
            }

            for (let group of payGroups) {
                this.addPayGroup(new PayGroup(this.game, group.dto, group.style.x, group.style.y));
                for (let i = 0; i < group.style.positions.length; i++) {
                    let payItemData = group.dto.items[i];
                    let payItem = new PayItem(this.game, payItemTextFormat, this.style.payItemWidth, this.style.payItemHeight, payItemData, group.style.positions[i].x, group.style.positions[i].y);
                    this.payGroups[this.payGroups.length - 1].addPayItem(payItem);
                }
            }
        }

        /**
         * If the paytableData is provided in the constructor this method will be automatically called
         * otherwise call it manually after you set the paytableData
         * @param data
         */
        public createPaytable(data: PaytableData) {
            this.createFromData();
            this.game.portalAPI.resourceProvider.registerTranslatableObject(this);            
        }
    }
}